var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C17.9941 0 23.5 4.55664 23.5 8C23.5 11.4434 17.9941 16 12 16C6.00594 16 0.5 11.4434 0.5 8C0.5 4.55664 6.00594 0 12 0ZM12 2C7.03573 2 2.5 5.7537 2.5 8C2.5 10.2463 7.03573 14 12 14C16.9643 14 21.5 10.2463 21.5 8C21.5 5.7537 16.9643 2 12 2ZM12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4ZM12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeHide);
export default __webpack_public_path__ + "static/media/icon-eye-hide.6b53030dfeb19cf8eb52a1d332b9e6b9.svg";
export { ForwardRef as ReactComponent };